import DealsTable from "./DealsTable";

export default DealsTable;
